const InputSelect = ({
  options = [],
  onChange,
  value,
}: {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Array<{ name: string; id: string }>;
}) => {
  return (
    <div
      className=" flex justify-between border border-neutral-5 rounded-4 text-14 pr-10"
      style={{ minWidth: 182 }}
    >
      <select
        className="w-full bg-transparent relative py-10 pl-10 focus:outline-none text-neutral-black font-600 text-opacity-60 truncate cursor-pointer"
        value={value}
        onChange={onChange}
      >
        {options.map((option, index) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InputSelect;
